import validate from "/usr/src/app/content/n3-promos-a9d41bd4-ff25-4c48-ad5c-e2a20ff2d080/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-promos-a9d41bd4-ff25-4c48-ad5c-e2a20ff2d080/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}